// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".9cc2ba9bed00a1d823c7d33bdbbbd039bb1f8e1f.chunk.bundle.js";
};